<div class="setting-container" [class.disabled]="disabled">
  <div class="header flex flex-row gap-[16px] justify-start items-center w-fit">
    <div class="flex flex-row gap-[8px] justify-start items-center">
      <h3>{{ title }}</h3>
    </div>
    <div class="flex flex-row gap-[16px] justify-center items-center">
      <mat-select
        mat-select-height-medium
        fieldTextContentTooltip
        [value]="feature.properties?.value?.value"
        (selectionChange)="onSelectFeatureValue($event.value)"
        [disabled]="disabled"
      >
        <mat-option *ngFor="let limit of limits" [value]="limit" fieldTextContentTooltip>
          {{ limit }} {{ feature | unit: 'value' }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="setting-content-wrapper">
    <ng-content></ng-content>
  </div>
</div>
